export default [
    {
        service: 'constant_contact_partner',
        label: 'Constant Contact (partner)',
        icon: 'icon-social-dropbox',
        implemented: true,
        authType: 'basic',
        primaryContactList: null,
        accessLevel: 'admin'
    },
    // {
    //     service: 'constant_contact',
    //     label: 'Constant Contact',
    //     icon: 'icon-social-dropbox',
    //     implemented: true,
    //     authType: 'oauth2',
    //     primaryContactList: null,
    //     accessLevel: 'director'

    // },
    // {
    //     service: 'active_campaign',
    //     label: 'Active Campaign',
    //     icon: 'icon-envelope',
    //     implemented: false,
    //     authType: 'oauth2',
    //     primaryContactList: null,
    //     accessLevel: 'director'
    // }
]